import { Form } from "react-bootstrap";
import { useAgentViewPreferences } from "../viewPreferences/agentViewPreferences";

const TextFilterControl = ({
  componentId,
  placeholder,
}: {
  componentId?: string;
  placeholder?: string;
}) => {
  const { getComponentTextFilter, setComponentTextFilter } =
    useAgentViewPreferences();

  const textFilter = getComponentTextFilter(componentId);

  return componentId ? (
    <Form.Control
      type="search"
      name="Filter by content"
      value={textFilter}
      placeholder={placeholder ?? "Filter by content..."}
      className="font-monospace"
      style={{ fontSize: "0.875rem" }}
      onChange={(e) => setComponentTextFilter(componentId, e.target.value)}
    />
  ) : null;
};

export default TextFilterControl;
